module.exports = __webpack_public_path__ + "img/carousel-3.54bc08f9.jpg";